import axios from 'axios'

const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/v2/admin/delegated-claims`
const baseUrl2 = `${process.env.REACT_APP_BACKEND_HOST}/v2/admin/prescriptions`
const axiosInstance = axios.create()

/**
 * 위임 신청 목록 조회 (DREFT 상태 제외)
 * @returns
 */
export const getDelegatedClaimsList = async ({
  page = 0,
  size = 10,
  sort = 'createdAt,desc',
}) => {
  try {
    const res = await axios.get(`${baseUrl}`, {
      params: { page, size, sort },
    })
    return res
  } catch (error) {
    console.log('getDelegatedClaimsList error:', error.response?.data || error)
  }
}

/**
 * 위임장 문서 조회
 * @param {*} param
 * @returns
 */
export const getDelegatedClaimsDocument = async ({ id }) => {
  try {
    const res = await axios.get(`${baseUrl}/${id}/attachment`)
    return res
  } catch (error) {
    console.log(
      'getDelegatedClaimsDocument error:',
      error.response?.data || error,
    )
  }
}

/**
 * 위임장 상세 조회
 * @param {*} param
 * @returns
 */
export const getDelegatedClaimsDetail = async ({ id }) => {
  try {
    const res = await axios.get(`${baseUrl}/${id}`)
    return res
  } catch (error) {
    console.log(
      'getDelegatedClaimsDetail error:',
      error.response?.data || error,
    )
  }
}

/**
 * 위임장 공단 승인
 * @param {*} param
 * @returns
 */
export const approveDelegatedClaim = async ({ id }) => {
  try {
    const res = await axios.post(`${baseUrl}/${id}/approve`)
    return res
  } catch (error) {
    console.log('approveDelegatedClaims error:', error.response?.data || error)
  }
}

/**
 * 위임장 공단 반려
 * @param {*} param
 * @returns
 */
export const rejectDelegatedClaim = async ({ id, rejectionReason }) => {
  try {
    const res = await axios.post(`${baseUrl}/${id}/reject`, {
      rejectionReason,
    })
    return res
  } catch (error) {
    console.log('rejectDelegatedClaims error:', error.response?.data || error)
  }
}

// ------------------------------------------------------------------------------ 처방전 관련 API ------------------------------------------------------------------------------ //

/**
 * 처방전 신청 목록 조회
 * @returns
 */
export const getPrescriptionClaimsList = async ({
  page = 0,
  size = 10,
  sort = 'createdAt,desc',
}) => {
  try {
    const res = await axios.get(`${baseUrl2}`, {
      params: { page, size, sort },
    })
    return res
  } catch (error) {
    console.log(
      'getPrescriptionClaimsList error:',
      error.response?.data || error,
    )
  }
}

/**
 * 처방전 단건 조회
 */
export const getPrescriptionClaim = async ({ id }) => {
  try {
    const res = await axios.get(`${baseUrl2}/${id}`)
    return res
  } catch (error) {
    console.log('getPrescriptionClaim error:', error.response?.data || error)
  }
}

/**
 * 처방전 메모 업데이트
 */
export const updatePrescriptionMemo = async ({ id, memo }) => {
  try {
    const res = await axios.post(`${baseUrl2}/${id}/memo`, {
      memo,
    })
    return res
  } catch (error) {
    console.log('updatePrescriptionMemo error:', error.response?.data || error)
  }
}

/**
 * 처방전 관리자 반려
 */
export const adminRejectPrescription = async ({ id, rejectionReason }) => {
  try {
    const res = await axios.post(`${baseUrl2}/${id}/admin-reject`, {
      rejectionReason,
    })
    return res
  } catch (error) {
    console.log('adminRejectPrescription error:', error.response?.data || error)
  }
}

/**
 * 처방전 관리자 승인
 */
export const adminApprovePrescription = async ({ id }) => {
  try {
    const res = await axios.post(`${baseUrl2}/${id}/admin-approve`)
    return res
  } catch (error) {
    console.log(
      'adminApprovePrescription error:',
      error.response?.data || error,
    )
  }
}

/**
 * 처방전 공단 반려
 */
export const rejectPrescriptionByHealthInsurance = async ({
  id,
  rejectionReason,
}) => {
  try {
    const res = await axios.post(`${baseUrl2}/${id}/reject`, {
      rejectionReason,
    })
    return res
  } catch (error) {
    console.log(
      'rejectPrescriptionByHealthInsurance error:',
      error.response?.data || error,
    )
  }
}

/**
 * 처방전 공단 승인
 */
export const approvePrescriptionByHealthInsurance = async ({ id }) => {
  try {
    const res = await axios.post(`${baseUrl2}/${id}/approve`)
    return res
  } catch (error) {
    console.log(
      'approvePrescriptionByHealthInsurance error:',
      error.response?.data || error,
    )
  }
}

/**
 * 처방전 최종 승인 (공단 반려 상태에서)
 */
export const finalizedPrescriptionByHealthInsurance = async ({ id }) => {
  try {
    const res = await axios.post(`${baseUrl2}/${id}/finalize`)
    return res
  } catch (error) {
    console.log(
      'finalizedPrescriptionByHealthInsurance error:',
      error.response?.data || error,
    )
  }
}

/**
 * 처방전 이미지 조회
 * @param {*} param
 * @param {string} param.token - 보안 파일 조회용 토큰
 * @returns
 */
export const getPrescriptionImage = async ({ token }) => {
  try {
    // 토큰에 대괄호([, ])가 포함되어 있어서 URL 인코딩이 필요함
    // paramsSerializer를 사용하여 모든 특수문자를 제대로 인코딩
    const res = await axios.get(`${baseUrl2}/view`, {
      params: { token },
      paramsSerializer: (params) => {
        // 각 파라미터를 명시적으로 인코딩
        const searchParams = new URLSearchParams()
        Object.keys(params).forEach((key) => {
          searchParams.append(key, params[key])
        })
        return searchParams.toString()
      },
      responseType: 'blob', // 바이너리 데이터(이미지)를 받기 위해
    })
    return res
  } catch (error) {
    // 400 에러인 경우 응답 데이터 확인
    if (error.response?.status === 400) {
      console.error('getPrescriptionImage 400 error:', {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers,
        requestUrl: error.config?.url,
        requestParams: error.config?.params,
      })
    } else {
      console.error('getPrescriptionImage error:', {
        message: error.message,
        code: error.code,
        response: error.response?.data,
        status: error.response?.status,
        config: {
          url: error.config?.url,
          params: error.config?.params,
        },
      })
    }
    throw error
  }
}
